/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ActivityRow } from "./ActivityRow";
import type { AutomationCard } from "./AutomationCard";

/**
 * One page of Activity's table, newest first: Waiting for approval's
 * cards, each with what approving it would do now (preview), or Done's
 * rows. total: how many the search and the actions picked hold, across
 * every page. counts: how many of each action the search holds, whatever
 * is picked (a message is send). left_out: how many of total Approve all
 * leaves out, held because details could not be filled in.
 */
export type ActivityPage = {
  view: ActivityPage.view;
  waiting?: Array<AutomationCard>;
  done?: Array<ActivityRow>;
  total: number;
  left_out?: number;
  counts: Record<string, number>;
};

export namespace ActivityPage {
  export enum view {
    WAITING = "waiting",
    DONE = "done",
  }
}
